"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getDay = _interopRequireDefault(require("date-fns/getDay"));
var _getNextDay = _interopRequireDefault(require("../getNextDay"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Function that returns the next working day for a branch
 * This will make sure, once pickup date is selected
 * dropoff date will not fall on a holiday
 * @param {Date} selectedDay
 * @param {Array} offDays
 * @returns {Date}
 */
function getNextWorkingDay(selectedDay, offDays) {
  var dayOfWeek = (0, _getDay["default"])(selectedDay);
  var isOffDay = offDays.indexOf(dayOfWeek) !== -1;
  // console.log('is dropoff an off day', isOffDay);

  if (isOffDay) {
    // recursion
    return getNextWorkingDay((0, _getNextDay["default"])(selectedDay), offDays);
  }
  return selectedDay;
}
var _default = exports["default"] = getNextWorkingDay;